import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import Main from './Pages/Main';
import 'bootstrap/dist/css/bootstrap.min.css';
import EditFeatureFlagPage  from './Pages/EditFeatureFlagPage';
import AddFeatureFlagPage from './Pages/AddFeatureFlagPage';
import AddConfigurationPage from './Pages/AddConfigurationPage';
import EditConfigurationPage from './Pages/EditConfigurationPage';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import LoginPage from './Pages/LoginPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <div className="App">
      <Navbar bg="dark" variant="dark">
            <Navbar.Brand as={Link} to="/" >
              <h1>Feature Flag API</h1>
            </Navbar.Brand>
              <Nav className="mr-auto">
                <NavItem eventkey={1} href="/">
                  <Nav.Link as={Link} to="/" >Home</Nav.Link>
                </NavItem>
              </Nav>
          </Navbar>
    </div>
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path='login/' element={<LoginPage />} />
      <Route path="featureflag/add" element={<AddFeatureFlagPage />} />
      <Route path="featureflag/edit" element={<EditFeatureFlagPage />} />
      <Route path="configuration/add" element={<AddConfigurationPage />} />
      <Route path="configuration/edit" element={<EditConfigurationPage />} />
    </Routes>
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
